import { HomeHero } from "../components/home/HomeHero";
import { CompetitionShowcase } from "../components/home/CompetitionShowcase";
import { FeaturedTokens } from "../components/home/FeaturedTokens";
import { TopMovers } from "../components/home/TopMovers";

export default function Home() {
  return (
    <div className="mx-auto max-w-[1500px] space-y-14 px-3 py-6 lg:px-6" data-testid="home-page">
      <CompetitionShowcase />
      <HomeHero />
      <FeaturedTokens />
      <TopMovers />
    </div>
  );
}
